import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MarketHomePage } from 'components/market-home/MarketHomePage';

const MarketShop = () => {
  const { sport } = useSportContext();
  return <MarketHomePage sport={sport} />;
};

export default MarketShop;
